// extracted by mini-css-extract-plugin
export default {"disabled":"PasswordVisibilityIcon_disabled__Fz0-V","active":"PasswordVisibilityIcon_active__nCtEE"};